module.exports = "<div class=\"tv-partners\">\n        <div class=\"tv-partners__img\" v-for=\"partner in partners\" :key=\"partner.id\" :style=\"{ backgroundImage: 'url(' + partner.logo + ')' }\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/tv-partners/tv-partners.vhtml
// module id = 267
// module chunks = 0